import React from 'react'

interface SEOProps {
  title?: string
  description?: string
  canonical?: string
  noindex?: boolean
  openGraph?: {
    type?: string
    title?: string
    description?: string
    image?: string
    url?: string
    siteName?: string
  }
  twitter?: {
    card?: 'summary' | 'summary_large_image'
    site?: string
    title?: string
    description?: string
    image?: string
  }
  jsonLd?: Array<Record<string, unknown>> | Record<string, unknown>
}

const asArray = (v?: Array<Record<string, unknown>> | Record<string, unknown>) => {
  if (!v) return []
  return Array.isArray(v) ? v : [v]
}

export function SEO(props: SEOProps) {
  const {
    title,
    description,
    canonical,
    noindex,
    openGraph,
    twitter,
    jsonLd,
  } = props

  return (
    <>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      {openGraph?.type && <meta property="og:type" content={openGraph.type} />}
      {openGraph?.title && <meta property="og:title" content={openGraph.title} />}
      {openGraph?.description && (
        <meta property="og:description" content={openGraph.description} />
      )}
      {openGraph?.image && <meta property="og:image" content={openGraph.image} />}
      {openGraph?.url && <meta property="og:url" content={openGraph.url} />}
      {openGraph?.siteName && <meta property="og:site_name" content={openGraph.siteName} />}

      {/* Twitter */}
      {twitter?.card && <meta name="twitter:card" content={twitter.card} />}
      {twitter?.site && <meta name="twitter:site" content={twitter.site} />}
      {twitter?.title && <meta name="twitter:title" content={twitter.title} />}
      {twitter?.description && (
        <meta name="twitter:description" content={twitter.description} />
      )}
      {twitter?.image && <meta name="twitter:image" content={twitter.image} />}

      {/* JSON-LD */}
      {asArray(jsonLd).map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  )
}

export default SEO


